import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP_URL } from "@/App";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="whatsapp-float-btn"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.8, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2.5 bg-[#25D366] text-slate-900 font-semibold px-4 py-3.5 md:px-5 md:py-4 animate-wa-pulse hover:bg-[#1eb857] hover:-translate-y-1 transition-[background-color,transform] duration-150"
      aria-label="Get a quote via WhatsApp"
    >
      <WhatsappLogo size={24} weight="fill" />
      <span className="hidden sm:inline text-sm">Free Demo — WhatsApp</span>
    </motion.a>
  );
}
